import { t as lnT } from '../../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import { GREEN, PALE_WHITE_2, WHITE } from '../../appearance/Colors';

const getAddCreditsHighlightParts = description => {
    if (typeof description !== 'string') {
        return null;
    }

    const match = description.match(/add(?:\s+lucky)?\s+credits/i);
    if (!match || typeof match.index !== 'number') {
        return null;
    }

    return {
        before: description.slice(0, match.index),
        highlighted: match[0],
        after: description.slice(match.index + match[0].length)
    };
};

const CreditsRequiredModal = ({
    isOpen,
    onRequestClose,
    onCheckout,
    title = lnT('common:luckyCreditsRequired'),
    description = lnT('common:insufficientCreditsPleaseAddCreditsToContinue')
}) => {
    const {t: lnT} = useTranslation();

    const highlightedDescription = getAddCreditsHighlightParts(description);

    return (
        <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={modalStyles}>
            <Wrapper>
                <Title>{title}</Title>
                <Description>
                    {highlightedDescription && typeof onCheckout === 'function' ? (
                        <>
                            {highlightedDescription.before}
                            <DescriptionAction type="button" onClick={onCheckout}>
                                {highlightedDescription.highlighted}
                            </DescriptionAction>
                            {highlightedDescription.after}
                        </>
                    ) : (
                        description
                    )}
                </Description>
                <Footer>
                    <SecondaryButton type="button" onClick={onRequestClose}>{lnT('onboarding:notNow')}</SecondaryButton>
                    <PrimaryButton type="button" onClick={onCheckout}>{lnT('common:addCredits')}</PrimaryButton>
                </Footer>
            </Wrapper>
        </Modal>
    );
};

const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        color: WHITE,
        maxWidth: 520,
        width: '92vw',
        borderRadius: 10,
        border: 'none',
        background: '#222729',
        padding: 0,
        overflow: 'hidden'
    }
};

const Wrapper = styled.div`
    padding: 24px;
    color: ${WHITE};
`;

const Title = styled.h2`
    margin: 0;
    font-size: 18px;
    font-weight: 600;
`;

const Description = styled.p`
    margin: 10px 0 0 0;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.7);
`;

const DescriptionAction = styled.button`
    border: 0;
    background: transparent;
    padding: 0;
    margin: 0;
    color: ${GREEN};
    text-decoration: underline;
    font: inherit;
    cursor: pointer;
`;

const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 22px;
`;

const ButtonBase = styled.button`
    border: 0;
    border-radius: 8px;
    padding: 8px 14px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
`;

const SecondaryButton = styled(ButtonBase)`
    background: ${PALE_WHITE_2};
    color: ${WHITE};
`;

const PrimaryButton = styled(ButtonBase)`
    background: ${GREEN};
    color: ${WHITE};
`;

export default CreditsRequiredModal;
